module.exports = __webpack_public_path__ + "img/032-pet.3af913ed.svg";